const ExampleRouter = [
    // Redirect To Main Example Page
    {
        path: "/example",
        redirect: {name: "example.main"}
    },
    /** Index */
    {
        path: "main",
        name: "example.main",
        component: () => import('@/views/example/sub/ExampleMain'),
    },
    /** BaseTableLayout */
    {
        path: "components/base-table-layout",
        name: "example.components.base-table-layout",
        component: () => import('@/views/example/sub/ExampleBaseTableLayout'),
    },
    /** ComponenetTable */
    {
        path: "components/component-table",
        name: "example.components.component-table",
        component: () => import('@/views/example/sub/ExampleComponentTable'),
    },
    /** InfinitePaginationTable */
    {
        path: "components/infinite-pagination-table",
        name: "example.components.infinite-pagination-table",
        component: () => import('@/views/example/sub/ExampleInfinitePaginationTable'),
    },
    /** MpsDataTable */
    {
        path: "components/form-data-table",
        name: "example.components.mps-data-table",
        component: () => import('@/views/example/sub/ExampleMpsDataTable'),
    },
    {
        path: "components/vue-data-table",
        name: "example.components.vue-data-table",
        component: () => import('@/views/example/sub/ExampleVueDataTable'),
    },
];

export default ExampleRouter;